import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'public/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserProfileService {

  constructor(private http: HttpClient) { }

  getTrainerBio(trainerId: string) {
    return this.http.get(`${environment.apiUrl}/UserProfile/GetTrainerBio?TrainerId=${trainerId}`);
  }
}
